<li class="nav-item menu-language">
  <button
    data-testid="languageMenuBtn"
    [matMenuTriggerFor]="dropDownComponent.menu"
    class="nav-link d-flex align-items-center"
    type="button">
    <i class="pbi-icon-outline pbi-globe" aria-hidden="true"></i>
    <span class="d-none d-lg-inline-block ms-1" data-testid="selectedLanguage">{{
      currentLang$ | async | titlecase
    }}</span>
    <span class="d-lg-none" id="help-offscreen"> <i class="pbi-icon-mini" aria-hidden="true"></i>&nbsp;Flag </span>
  </button>
</li>
<app-dropdown-menu #dropDownComponent identifier="languageItem" [menuItems]="languageMenuItems" />
